import { getTenantInfo, sendRequest } from 'utils/utils'
import Infra from '../../mobx/Infra'

interface tenantUrls {
	storeAndMenuJsonURL: string
	webFlowAddressURL: string
	tenantDetailsURL: string
}

interface storeUrls {
	storeAndMenuJsonURL: string
	storeDetailsUrl: string
}

export enum TenantUrlPickOptions {
	WebFlowAddressURL = 'webFlowAddressURL',
	StoreAndMenuJsonURL = 'storeAndMenuJsonURL',
	TenantDetailsURL = 'tenantDetailsURL',
}

const tenantUrlsCache: Record<string, Promise<tenantUrls>> = {}
const storeUrlsCache: Record<string, Promise<storeUrls>> = {}
let lastUrl: string | null = null

const resetCacheIfRouteChanged = () => {
	if (typeof window === 'undefined') {
		return
	}

	const currentUrl = window.location.href

	if (lastUrl !== currentUrl) {
		lastUrl = currentUrl
		Object.assign(tenantUrlsCache, {})
		Object.assign(storeUrlsCache, {})
	}
}

export const storeUrls = async (storeId: string): Promise<storeUrls> => {
	resetCacheIfRouteChanged()

	if (!storeUrlsCache[storeId]) {
		storeUrlsCache[storeId] = sendRequest(
			true,
			`${Infra?.appParams?.storefrontUrl || process.env.STOREFRONT_API_URL}/v1/stores/${storeId}/urls`,
			'get',
			null,
			null,
			true,
			90000,
			null,
			false
		) as Promise<storeUrls>
	}
	return storeUrlsCache[storeId]
}

export const tenantUrls = async (pickOptions: TenantUrlPickOptions[], tenantId?: string, showLoader = true): Promise<tenantUrls> => {
	resetCacheIfRouteChanged()

	const resolvedTenantId = tenantId || getTenantInfo()
	const pickKey = pickOptions.sort().join(',')
	const cacheKey = `${resolvedTenantId}|${pickKey}`

	if (!tenantUrlsCache[cacheKey]) {
		const pickQuery = pickOptions.join(',')
		tenantUrlsCache[cacheKey] = sendRequest(
			showLoader,
			`${Infra?.appParams?.storefrontUrl || process.env.STOREFRONT_API_URL}/v1/tenants/${resolvedTenantId}/urls?$pick=${pickQuery}`,
			'get',
			null,
			null,
			true,
			90000,
			null,
			false
		) as Promise<tenantUrls>
	}

	return tenantUrlsCache[cacheKey]
}
